import BlogPostMetaData from "../../../../src/components/BlogPostMetaData";
import * as React from 'react';
export default {
  BlogPostMetaData,
  React
};